import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DealerPortalService } from 'src/app/services/dealerPortal.service';
import { Subscription } from 'rxjs';
import { CustomerService } from 'src/app/services/customer.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-marketing-activity-cost',
  templateUrl: './marketing-activity-cost.component.html',
  styleUrls: ['./marketing-activity-cost.component.less']
})
export class MarketingActivityCostComponent implements OnInit {
  @Input() tabSelectedIndex: number | undefined;
  isResetting = false;
  firstLoading = true;
  pageNum = 1;
  totalNum = 4;
  searchFormData!: FormGroup;
  loading = false;
  ranges: any;
  date = null;
  statusList: any = ['待审批', '待上传附件', '开票中', '核销中', '付款中', '已完成'];
  // approvalStatusList: any = ['审批中', '审批通过', '审批拒绝', '撤回'];
  approvalStatusList: any = ['开票中', '核销中', '付款中', '已完成'];
  activityList: any = [];
  productLineList: any = [];
  chartData = [
    { label: '申请金额', value: 0, color: '#9E2896' },
    { label: '预计付款金额', value: 0, color: '#F19F23' },
    { label: '实际付款金额', value: 0, color: '#18837E' },
  ];
  private customerSubscription: Subscription | undefined;

  constructor(private fb: FormBuilder,
    private customerService: CustomerService,
    private router: Router,
    private translate: TranslateService,
    private dealerPortalService: DealerPortalService) { }

  ngOnInit() {
    this.initData().then(() => {
      this.firstLoading = false;
    })
    this.customerSubscription = this.customerService.selectedCustomer$.subscribe(() => {
      if (!this.firstLoading && this.router.url.includes('/marketing-activity') && this.tabSelectedIndex === 0) {
        this.initData();
      }
    });
  }

  ngOnDestroy(): void {
    if (this.customerSubscription) {
      this.customerSubscription.unsubscribe();
    }
  }

  initData(): Promise<void> {
    return new Promise((resolve) => {
      this.searchFormData = this.fb.group({
        activityRequestNo: "",
        verificationCode: "",
        productLine: "",
        approvalStatus: "",
        yearRange: null,
      });
      this.getMarketingProcessFee()
      this.getFeeFilterList()
      resolve();
    })
  }

  formatMoney(value: any, decimals = 2): string {
    if (value === null || value === undefined || value === '' || value === 0) {
      return '-';
    }

    const num = Number(value);
    if (isNaN(num)) {
      return String(value);
    }

    return num
      .toFixed(decimals)
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  onPageIndexChange(pageIndex: number) {
    this.pageNum = pageIndex;
    this.getMarketingProcessFee()
  }

  onYearChange(result: Date[]): void {
    console.log('onChange: ', result);
  }

  filterMarketingProcessFee() {
    this.pageNum = 1;
    this.getMarketingProcessFee();
  }

  getMarketingProcessFee() {
    if (this.isResetting) return;
    const filters = this.searchFormData.value;
    let startYear = '';
    let endYear = '';
    if (filters.yearRange && filters.yearRange.length > 0) {
      const [start, end] = filters.yearRange;
      startYear = new Date(start).getFullYear().toString();
      endYear = new Date(end).getFullYear().toString();
    }
    const param = {
      pageNum: this.pageNum,
      pageSize: 4,
      activityRequestNo: filters.activityRequestNo,
      verificationCode: filters.verificationCode,
      productLine: filters.productLine,
      approvalStatus: filters.approvalStatus,
      startYear: startYear,
      endYear: endYear,
    }
    this.loading = true;
    this.dealerPortalService.getMarketingProcessFee(param).subscribe(result => {
      const { rtnCode, rtnData } = result;
      this.activityList = rtnData.records;
      this.pageNum = rtnData.current;
      this.totalNum = rtnData.total;
      this.loading = false;
    })
    this.dealerPortalService.getMarketingFeeTotalAmount(param).subscribe(result => {
      const { rtnCode, rtnData } = result;
      const { totalRequestedAmount, totalExpectedPaymentAmount, totalActualPaymentAmount } = rtnData;
      this.chartData[0].value = totalRequestedAmount;
      this.chartData[1].value = totalExpectedPaymentAmount;
      this.chartData[2].value = totalActualPaymentAmount;
    })
  }

  getFeeFilterList() {
    this.dealerPortalService.getFeeFilterList().subscribe(result => {
      const { rtnCode, rtnData } = result;
      this.productLineList = rtnData.productLines;
    })
  }

  clear(): void {
    this.isResetting = true;
    this.searchFormData.reset();
    this.isResetting = false;
    this.getMarketingProcessFee();
  }
}
